{
  "kind": {
    "held": "الأمانات المحتفظ بها",
    "delivered": "الأمانات المسلمة",
    "detailed": "كشف تفصيلي",
    "by-customer": "حسب العميل",
    "by-employee": "حسب الموظف"
  },
  "description": {
    "held": "رصيد الأمانات في حوزتنا لكل عملة. هذا سجل أمانات وليس رصيد صندوق الفرع.",
    "delivered": "الأمانات المسلمة والمستردة حسب تاريخ التسليم.",
    "detailed": "كل الأمانات ضمن الفلاتر.",
    "by-customer": "أمانات كل عميل كمودع أو مستلم.",
    "by-employee": "الأمانات المستلمة وعمليات التسليم والإرجاعات لكل موظف، كل منها على حدة."
  },
  "any": "الكل",
  "customer": "العميل",
  "customerPlaceholder": "اسم العميل أو هاتفه",
  "employee": "الموظف",
  "recipient": "المستلم",
  "depositDate": "تاريخ الإيداع",
  "deliveryDate": "تاريخ التسليم",
  "totals": "المجاميع حسب العملة",
  "heldTotals": "المحتفظ به حسب العملة",
  "heldNote": "كل عملة لها مجموعها الخاص ولا تجمع العملات معا.",
  "countLabel": "العدد {{formatted}}",
  "asDepositor": "كمودع",
  "asRecipient": "كمستلم",
  "depositsReceived": "الأمانات المستلمة",
  "deliveriesMade": "عمليات التسليم",
  "returnsMade": "عدد الإرجاعات",
  "exportPdf": "تصدير PDF"
}
